export default __webpack_public_path__ + "static/media/test-facebook.e960fb37.svg";